import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { BorderColor } from '@mui/icons-material';

const BrandsCovered = ({ open, onClose, title, children }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-title">
      <Box className="modal-box-brands">
        <Box
          display="flex"
          justifyContent="flex-start"
          alignItems="center"
          mb={2}
          className="modal-header"
        >
          <Typography
            id="modal-title"
            variant="h6"
            style={{ color: '#003cc5' }}
            component="h2"
          >
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        {children}
      </Box>
    </Modal>
  );
};

BrandsCovered.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
};

BrandsCovered.defaultProps = {
  title: '',
  children: null,
};

export default BrandsCovered;
